
import ViewPulse from './ViewPulse'

const ViewPulsePreview = ({
  uid,
  db,
  setSavedLocation,
  displayName,
  email,
  analytics
}) => {
  return (
    <ViewPulse
      uid={uid}
      db={db}
      setSavedLocation={setSavedLocation}
      displayName={displayName}
      email={email}
      analytics={analytics}
      isPreview={true}
    />
  )
}

export default ViewPulsePreview
